import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

interface LineChartProps {
  title: string;
  years: string[];
  series: { name: string; data: number[] }[];
}

export function LineChart({ title, years, series }: LineChartProps) {
  const options: Highcharts.Options = {
    title: { text: title },
    chart: { type: 'line' },
    xAxis: { categories: years },
    yAxis: { title: { text: 'Risk Increase (%)' } },
    series: series as Highcharts.SeriesOptionsType[],
    tooltip: { valueSuffix: '%' },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
